import { GRAY_100, GRAY_600 } from 'constants/styling/theme'

import { FC } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

/**
 * Non-intrusive disclaimer reminding users that AI responses may be inaccurate (ticket DOD).
 *
 * Not mounted while the widget's only flow is the Ops support conversation (ISSUE-2345) — a human answers
 * there, so the AI warning would mislabel it. Render it wherever AI actually replies (AI_SUPPORT).
 */
export const AIDisclaimer: FC = () => {
  const { t } = useTranslation(['chat'])

  return (
    <Stack
      direction="row"
      gap="0.6rem"
      alignItems="center"
      justifyContent="center"
      sx={{ padding: '0.8rem 1.2rem', backgroundColor: GRAY_100 }}
    >

      <InfoOutlinedIcon sx={{ fontSize: '1.6rem', color: GRAY_600 }} />

      <Typography variant="text-xs" color={GRAY_600} textAlign="center">
        {t('chat:ai_disclaimer')}
      </Typography>

    </Stack>
  )
}
